/* Tysk katalog for locale-firm-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'rf.loading.firm': 'Dein Büro wird geladen …',
  'rf.loading.clients': 'Deine Mandanten werden abgerufen …',
  'rf.loading.reconciliation': 'Die Abgleiche werden abgerufen …',
  'rf.loading.control': 'Die Prüfaufgaben werden abgerufen …',
  'rf.loading.ledger': 'Die Buchhaltung des Mandanten wird geladen …',
  'rf.pageError.title': 'Die Seite konnte nicht geladen werden',
  'rf.pageError.text': 'Lade den Bürobereich neu. Wenn es weiterhin auftritt, ist das Skript für diese Seite nicht verfügbar.',
  'rf.client.assignCount': 'Zuweisen ({count})',
  'rf.client.assignAll': 'Alle im Büro',
  'rf.client.assignNobody': 'Das Büro hat noch keine aktiven Mitarbeitenden, die dem Mandat zugewiesen werden können.',
  'rf.client.assignRoleHint': 'Die Rolle gilt für alle, die du angekreuzt hast. Wer bereits zugewiesen ist, erhält die neue Rolle.',
  'rf.client.assignedMany': '{count} Mitarbeitende wurden dem Mandat zugewiesen',
  'rf.nav.myPage': 'Meine Seite',
  'rf.nav.firmBooks': 'Zur Buchhaltung des Büros',
});
